import clsx from 'clsx'
import { TONE_BG, TONE_HEX, TONE_TEXT } from './tokens'

export type PressureTone = 'ok' | 'warn' | 'danger'

export interface PressureBar {
  label?: string
  value: number
  tone: PressureTone
}

export interface CorridorPressureProps {
  title: string
  verdict: string
  verdictTone: PressureTone
  bars: PressureBar[]
  axis: [string, string, string]
}

export function CorridorPressure({ title, verdict, verdictTone, bars, axis }: CorridorPressureProps) {
  const [axisLeft, axisMid, axisRight] = axis
  return (
    <div className="w-[264px] rounded-[12px] border border-[rgba(15,23,42,0.07)] bg-white/95 p-3 shadow-[0_2px_8px_rgba(15,23,42,0.08)] backdrop-blur-sm">
      <div className="flex items-center justify-between gap-2">
        <span className="text-[10px] font-medium uppercase tracking-[0.12em] text-[#94A3B8]">{title}</span>
        <span
          className={clsx(
            'rounded-full px-2 py-0.5 text-[10px] font-semibold',
            TONE_BG[verdictTone],
            TONE_TEXT[verdictTone],
          )}
        >
          {verdict}
        </span>
      </div>
      <div className="mt-2.5 flex h-10 items-end gap-[3px]">
        {bars.map((bar, i) => {
          // 6% floor keeps zero-pressure segments visible as a baseline tick.
          const h = Math.max(0.06, Math.min(1, bar.value)) * 100
          return (
            <div
              key={i}
              title={bar.label}
              className="flex-1 rounded-[2px]"
              style={{ height: `${h}%`, backgroundColor: TONE_HEX[bar.tone] }}
            />
          )
        })}
      </div>
      <div className="mt-1.5 grid grid-cols-3 text-[10px] text-[#94A3B8]">
        <span>{axisLeft}</span>
        <span className="text-center">{axisMid}</span>
        <span className="text-right">{axisRight}</span>
      </div>
    </div>
  )
}
